import { cn } from "@/lib/utils";

export function DisplayNumeral({ index, className }: { index: number; className?: string }) {
  const padded = String(index + 1).padStart(2, "0");
  return (
    <span
      className={cn(
        "font-semibold text-4xl leading-none tabular-nums text-muted-foreground/40 select-none",
        className,
      )}
    >
      {padded}
    </span>
  );
}
